module.exports = __webpack_public_path__ + "static/media/SourceSansPro-SemiboldIt.94f43fd6.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-SemiboldIt.woff2
// module id = 344
// module chunks = 3